export type ExportOptionKey =
    | "companySettings"
    | "companyAndStateSettings"
    | "customerData"
    | "certificateData";

export type ExportOptions = Record<ExportOptionKey, boolean>;

export interface ExportOptionDefinition {
    key: ExportOptionKey;
    label: string;
}

/**
 * Display order matches CertCapture's DataMigration export form. Each option is a child of the one
 * before it (Account Settings, always exported, sits above the first), so the index is the depth.
 */
export const EXPORT_OPTION_DEFINITIONS: ExportOptionDefinition[] = [
    { key: "companySettings", label: "Company Settings" },
    { key: "companyAndStateSettings", label: "Company & States/Zone Settings" },
    { key: "customerData", label: "Customer Data" },
    { key: "certificateData", label: "Certificate Data" },
];

export const EMPTY_EXPORT_OPTIONS: ExportOptions = {
    companySettings: false,
    companyAndStateSettings: false,
    customerData: false,
    certificateData: false,
};

/**
 * Checking an option also checks every option above it; unchecking an option also unchecks every
 * option below it.
 */
export const applyOptionToggle = (
    options: ExportOptions,
    key: ExportOptionKey,
    checked: boolean
): ExportOptions => {
    const index = EXPORT_OPTION_DEFINITIONS.findIndex(option => option.key === key);
    const next = { ...options };
    EXPORT_OPTION_DEFINITIONS.forEach((option, i) => {
        if (checked && i <= index) {
            next[option.key] = true;
        } else if (!checked && i >= index) {
            next[option.key] = false;
        }
    });
    return next;
};

export const hasSelectedOption = (options: ExportOptions): boolean =>
    Object.values(options).some(Boolean);
